<template>
  <div class="header-component" v-if="getUser._id">
    <div class="header-bottom">
      <img
        class="header-logo"
        src="../../assets/img/logo_small.png"
        alt="MCK"
      />
      <div class="header-bottom-left">
        <router-link
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          to="/calendar"
        >
          <!-- <span class="mck2 mobile-inline">F</span> -->
          <img class="mobile" src="../../assets/img/header/mm-cal.svg" alt="" />
          <span>Календар</span>
        </router-link>
        <router-link
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          :class="{
            'header-bottom-tab-active': this.$route.name === 'inquiry',
          }"
          to="/inquiry"
          v-if="
            accessCache['full_inquiries'] || accessCache['personal_inquiries']
          "
        >
          <img class="mobile" src="../../assets/img/header/mm-spr.svg" alt="" />
          <span>Справки</span>
        </router-link>
        <router-link
          v-if="
            accessCache['planning'] ||
            accessCache['reporting'] ||
            accessCache['self_reports'] ||
            accessCache['accept_self_reports']
          "
          class="header-bottom-tab"
          exact-active-class="header-bottom-tab-active"
          to="/reports/own"
          :class="{
            'header-bottom-tab-active':
              this.$route.name === 'ownReports' ||
              this.$route.name === 'newReport' ||
              this.$route.name === 'editReport',
            'header-bottom-tab-active-orange':
              this.$route.query.plan === 'true',
          }"
        >
          <img class="mobile" src="../../assets/img/header/mm-rep.svg" alt="" />
          <span class="desktop">План/Отчет</span>
          <span class="mobile">Отчети</span>
        </router-link>
        <router-link
          class="header-bottom-tab"
          active-class="header-bottom-tab-active"
          v-if="accessCache['canSeeDeliveries']"
          to="/deliveries"
          :class="{
            'header-bottom-tab-active': this.$route.name === 'deliveries',
          }"
        >
          <img
            class="mobile"
            src="../../assets/img/header/mm-dost.svg"
            alt=""
          />
          <span>Доставки</span>
        </router-link>
        <router-link
          v-if="accessCache['companies_projects']"
          class="header-bottom-tab desktop"
          active-class="header-bottom-tab-active"
          to="/companies"
          :class="{
            'header-bottom-tab-active':
              this.$route.name === 'newCompany' ||
              this.$route.name === 'editCompany' ||
              this.$route.name === 'newProject' ||
              this.$route.name === 'newObject' ||
              this.$route.name === 'newPart' ||
              this.$route.name === 'getPart',
          }"
        >
          <span class="mck2 mobile-inline">C</span>
          <span>Отдели</span>
        </router-link>
        <router-link
          class="header-bottom-tab"
          active-class="header-bottom-tab-active"
          to="/inventory"
          v-if="accessCache['canSeeInventory']"
        >
          <img class="mobile" src="../../assets/img/header/mm-inv.svg" alt="" />
          <span>Инвентар</span>
        </router-link>
        <router-link
          v-if="accessCache['users_info'] || accessCache['users_roles']"
          class="header-bottom-tab desktop"
          :class="{
            'header-bottom-tab-active':
              $route.name === 'users' || $route.name === 'roles',
          }"
          to="/users/users"
        >
          <span class="mck2 mobile-inline">D</span>
          <span>Потребители</span>
        </router-link>
        <router-link
          v-if="accessCache['log']"
          class="header-bottom-tab desktop"
          exact-active-class="header-bottom-tab-active"
          to="/log"
        >
          <span class="mck2 mobile-inline">E</span>
          <span>Лог дневник</span>
        </router-link>
      </div>
      <div class="header-bottom-right">
        <TheInput
          icon="N"
          placeholder="Търсене"
          :dark="true"
          v-model="search"
          @input="sendSearchInput"
          v-if="
            this.$route.name !== 'inquiry' &&
            this.$route.name !== 'log' &&
            this.$route.name !== 'calendar'
          "
        />
        <section class="the-input-wrapper" v-else></section>
        <template v-if="getUser">
          <a
            title="Научете повече за новите функции"
            class="header-user desktop"
            :href="whatsnewPdf"
            target="_blank"
          >
            <span class="mck">x</span>
          </a>
          <div class="line desktop"></div>
          <div
            class="header-user desktop"
            v-if="
              getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin
            "
            @click="isUserNotificationsModalOpened = true"
          >
            <span title="Настройки на мейлите с нотификации" class="mck"
              >P</span
            >
          </div>
          <div class="header-user" @click="isUserModalOpened = true">
            <span class="mck">B</span>
          </div>
          <div class="line"></div>
          <span class="header-logout mck" @click="logout()">F</span>
        </template>
      </div>
    </div>
    <UserModal
      v-if="isUserModalOpened"
      :idToEdit="getUser._id"
      :limitedFunctionality="true"
    />
    <UserNotificationsModal
      v-if="isUserNotificationsModalOpened"
      @close="isUserNotificationsModalOpened = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserModal from "./UserModal";
import UserNotificationsModal from "./UserNotificationsModal";
import TheInput from "../TheInput.vue";
import { getAccess } from "../mixins/getAccess";
import tabsData from "../../data/tabsData";
export default {
  components: {
    UserModal,
    UserNotificationsModal,
    TheInput,
  },
  watch: {
    "$route.name"(to) {
      // don't reset search if route is 'newPart' or 'getPart', because that will make
      // a request to get all companies again and will reset the companies dropdown tree
      if (
        to !== "newPart" &&
        to !== "getPart" &&
        to !== "newProject" &&
        to !== "newObject"
      ) {
        this.search = "";
        this.sendSearchInput();
      }
    },
  },
  data() {
    return {
      tabsData,
      accessCache: {},
      isUserModalOpened: false,
      isUserNotificationsModalOpened: false,
      search: "",
      isSearchShown: false,
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      "getLoading",
      // ...
    ]),
    whatsnewPdf() {
      return `${process.env.VUE_APP_FILES_URI}/what-s-new-v3.pdf`;
    },
  },
  methods: {
    logout() {
      this.$store
        .dispatch("logout")
        .then(() => this.$router.push("/login"))
        .catch((err) => console.log(err));
    },
    // Send searched string globally
    sendSearchInput() {
      this.$root.$emit("sendSearchInput", this.search);
    },
    showInput() {
      this.isSearchShown = !this.isSearchShown;
      if (this.isSearchShown) {
        this.$nextTick(() => {
          this.$refs["searchInputField"].focus();
        });
      }
      this.search = "";
    },
    setAccessCache() {
      let accessViews = [
        { n: "full_inquiries", from: "inquiry" },
        { n: "personal_inquiries", from: "inquiry" },
        { n: "companies_projects", from: "companies" },
        { n: "users_info", from: "users" },
        { n: "users_roles", from: "users" },
        { n: "log", from: "log" },
        { n: "planning", from: "reports" },
        { n: "reporting", from: "reports" },
        { n: "self_reports", from: "reports" },
        { n: "accept_self_reports", from: "reports" },
      ];

      accessViews.forEach((t) => {
        this.$set(this.accessCache, t.n, getAccess(t.n, t.from));
      });

      // inventory access
      for (let i of Object.keys(this.tabsData.inventory.tabValues)) {
        if (getAccess(i, "inventory")) {
          this.$set(
            this.accessCache,
            "canSeeInventory",
            getAccess(i, "inventory")
          );
          break;
        }
      }
      // delivery access
      this.accessCache.canSeeDeliveries = getAccess(
        ["personal", "full"],
        "delivery"
      );
    },
  },
  mounted() {
    setTimeout(() => {
      this.setAccessCache();
    }, 200);
    this.$on("closeUserModal", (result) => {
      this.isUserModalOpened = false;
      // if result.isEdited = true, this means something is changed and we get the users again
      if (result.isEdited) {
        this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch((err) => console.log(err));
      }
    });
  },
  destroyed() {
    this.$off("closeUserModal");
  },
};
</script>

<style lang="scss">
.header-component {
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#EC6607+0,6D2600+100 */
  background: var(--color-main); /* Old browsers */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ec6607', endColorstr='#6d2600',GradientType=0 ); /* IE6-9 */
  width: 100%;

  .header-top,
  .header-bottom {
    align-items: center;
    display: flex;
    height: var(--header-height);
    justify-content: space-between;
    padding: 0 20px;
    width: 100%;
  }
  /* HEADER TOP */
  .header-logo {
    height: 30px;
    margin: 5px 10px 5px 0;
    width: auto;
  }
  .header-top-right {
    align-items: center;
    display: flex;
  }
  .header-user {
    align-items: center;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
    cursor: pointer;
    display: flex;
    height: 28px;
    margin-left: 5px;
    padding: 0 10px;
    -webkit-transition: background-color 0.3s;
    -moz-transition: background-color 0.3s;
    -ms-transition: background-color 0.3s;
    -o-transition: background-color 0.3s;
    transition: background-color 0.3s;
  }
  .header-user:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
  .header-user .mck {
    color: #fff;
    font-size: 16px;
    /* margin-right: 10px; */
  }
  .header-user p {
    color: #fff;
    font-size: 12px;
  }
  .line {
    background-color: #fff;
    opacity: 0.5;
    height: 28px;
    width: 1px;
  }
  .header-logout {
    align-items: center;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    display: inline-flex;
    height: 28px;
    padding: 0 10px;
    margin: 0 -10px 0 0;
    -webkit-transition: background-color 0.3s;
    -moz-transition: background-color 0.3s;
    -ms-transition: background-color 0.3s;
    -o-transition: background-color 0.3s;
    transition: background-color 0.3s;
  }
  .header-logout:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
  /* HEADER BOTTOM */
  .header-bottom-left {
    align-items: flex-end;
    display: flex;
    gap: 3px;
    height: 40px;
    width: 100%;
  }
  .header-bottom-tab {
    align-items: center;
    background-color: rgba(240, 240, 247, 0.2);
    border-radius: 4px 4px 0 0;
    color: #fff;
    font-size: 12px;
    display: flex;
    height: 30px;
    justify-content: center;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 110px;

    > span {
      font-size: clamp(10px, 2vw, 12px);
    }
  }
  .header-bottom-tab:hover {
    background-color: rgba(240, 240, 247, 0.3);
  }
  .header-bottom-tab-active {
    height: 33px;
    background-color: rgba(240, 240, 247, 1);
    color: #000;
  }
  .header-bottom-tab-active:hover {
    background-color: rgba(240, 240, 247, 1);
  }
  .header-bottom-tab-active-green,
  .header-bottom-tab-active-green:hover {
    background-color: #f0f7f7;
  }
  .header-bottom-tab-active-orange,
  .header-bottom-tab-active-orange:hover {
    background-color: #ece0c6;
  }
  .header-bottom-right {
    align-items: center;
    display: flex;

    .the-input-wrapper {
      .the-input {
        height: 28px;
        width: 250px;
      }
    }
  }

  .mobile,
  .mobile-inline {
    display: none;
  }
}
/* RESPONSIVE */
@media screen and (max-width: 1000px) {
  .header-component {
    height: auto;
    width: 100%;

    .desktop {
      display: none;
    }
    .mobile {
      display: flex;
    }
    .mobile-inline {
      display: inline;
    }
    .header-top,
    .header-bottom {
      padding: 0 15px;
      width: 100%;
    }
    .header-bottom {
      height: fit-content;
      // flex-wrap: wrap;

      .header-bottom-left {
        align-items: center;
        background: rgba(223, 225, 230, 0.5);
        backdrop-filter: blur(30px);
        border-radius: 10px 10px 0 0;
        bottom: 0;
        justify-content: center;
        height: var(--header--mobile-tabs-height);
        gap: 5px;
        position: fixed;
        padding: 0 10px;
        left: 0;
        width: 100%;
        z-index: 5;

        .header-bottom-tab {
          background: #dfe1e6;
          box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
          border-radius: 7px;
          color: #2c3e50;
          flex: 1;
          font-size: 16px;
          flex-direction: column;
          height: fit-content;
          padding: 5px;
          max-width: 100%;
          width: initial;

          &.header-bottom-tab-active {
            background: var(--color-main);
            color: #ffffff;

            img {
              filter: invert(100%) brightness(1000%);
            }
          }

          img {
            width: 30px;
          }
        }
      }
      .header-bottom-right {
        display: flex;
        flex: 1;

        .the-input-wrapper {
          flex: 1;

          .the-input {
            width: 100%;
          }
        }
      }
    }
    .header-top-right {
      justify-content: flex-end;
    }

    .header-user .mck {
      margin: 0;
    }
    .header-logout {
      margin: 0px;
    }
  }
}
</style>
